import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/scms-logo.png";

const SITE_URL = "/";

/** =========================
 *  샘플 메뉴 (DB/API 대체용)
 *  - 숫자는 쉼표 없이 입력
 *  ========================= */
const SAMPLE_MENUS = [
  // 1뎁스
  {
    ID: 1,
    MENU_NM: "게시판 관리",
    MENU_NO: 1000000,
    UPPER_MENU_NO: 0,
    LINK: "/cms",
    ICON: "fa-regular fa-rectangle-list me-2",
  },
  // 2뎁스 (게시판 관리 하위)
  {
    ID: 2,
    MENU_NM: "게시판 생성관리",
    MENU_NO: 1000100,
    UPPER_MENU_NO: 1000000,
    LINK: "/cms/boards/master",
    ICON: "fa-regular fa-square me-2",
  },
  {
    ID: 3,
    MENU_NM: "게시물 생성관리",
    MENU_NO: 1000200,
    UPPER_MENU_NO: 1000000,
    LINK: "/cms/boards/post",
    ICON: "fa-regular fa-pen-to-square me-2",
  },

  // 기타 1뎁스 (기존 고정 메뉴도 샘플로 여기에 포함)
  {
    ID: 4,
    MENU_NM: "팝업 관리",
    MENU_NO: 2000000,
    UPPER_MENU_NO: 0,
    LINK: "/cms/popups",
    ICON: "fa-regular fa-window-restore",
  },
  {
    ID: 5,
    MENU_NM: "통계 관리",
    MENU_NO: 3000000,
    UPPER_MENU_NO: 0,
    LINK: "/cms/usage",
    ICON: "fa-solid fa-chart-column",
  },
];

/** 그룹핑 유틸: 부모/자식 분리 */
function buildTrees(rows) {
  const parents = rows.filter((r) => r.UPPER_MENU_NO === 0);
  const children = rows.filter((r) => r.UPPER_MENU_NO !== 0);
  const byParent = parents.map((p) => ({
    parent: p,
    children: children.filter((c) => c.UPPER_MENU_NO === p.MENU_NO),
  }));
  return byParent;
}

export default function Sidebar() {
  const location = useLocation();
  const [trees] = useState(() => buildTrees(SAMPLE_MENUS));

  // 어떤 그룹을 펼칠지 상태(부모 MENU_NO: boolean)
  const [openMap, setOpenMap] = useState(() => {
    const init = {};
    trees.forEach(({ parent, children }) => {
      const shouldOpen = children.some((c) => location.pathname.startsWith(c.LINK));
      init[parent.MENU_NO] = shouldOpen;
    });
    return init;
  });

  // 라우트 변경 시 자동 펼침/접기 보정
  useEffect(() => {
    setOpenMap((prev) => {
      const next = { ...prev };
      trees.forEach(({ parent, children }) => {
        const shouldOpen =
          children.some((c) => location.pathname.startsWith(c.LINK)) ||
          location.pathname === parent.LINK;
        next[parent.MENU_NO] = shouldOpen;
      });
      return next;
    });
  }, [location.pathname, trees]);

  const toggle = (menuNo) =>
    setOpenMap((m) => ({
      ...m,
      [menuNo]: !m[menuNo],
    }));

  const renderIcon = (icon) =>
    icon && icon.trim().length ? (
      <i className={icon} />
    ) : (
      <i className="fa-regular fa-square me-2" />
    );

  return (
    <div className="sidebar">
      <div className="brand mb-2">
        <img className="brand-logo" src={logo} alt="SCMS" />
      </div>

      <nav className="nav flex-column">
        {trees.map(({ parent, children }) => {
          const isGroup = children.length > 0;
          const isOpen = !!openMap[parent.MENU_NO];

          // 1뎁스 + 하위가 있으면 드롭다운 버튼
          if (isGroup) {
            return (
              <div key={parent.MENU_NO}>
                <button
                  type="button"
                  className={
                    "nav-link d-flex align-items-center justify-content-between dropdown-toggle-btn " +
                    (isOpen ? "open" : "")
                  }
                  onClick={() => toggle(parent.MENU_NO)}
                >
                  <span className="d-flex align-items-center">
                    {renderIcon(parent.ICON)}
                    <span>{parent.MENU_NM}</span>
                  </span>
                  <i className={"fa-solid fa-chevron-" + (isOpen ? "up" : "down") + " small"} />
                </button>

                <div className={"submenu " + (isOpen ? "show" : "")}>
                  {children.map((c) => (
                    <NavLink key={c.MENU_NO} to={c.LINK} className={({ isActive }) => "nav-link " + (isActive ? "active" : "")}>
                      {renderIcon(c.ICON)}
                      <span>{c.MENU_NM}</span>
                    </NavLink>
                  ))}
                </div>
              </div>
            );
          }

          // 하위가 없으면 일반 NavLink
          return (
            <NavLink
              key={parent.MENU_NO}
              to={parent.LINK}
              className={({ isActive }) => "nav-link " + (isActive ? "active" : "")}
            >
              {renderIcon(parent.ICON)}
              <span>{parent.MENU_NM}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <a
          href={SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-rounded w-100"
          title="사이트 새 탭에서 열기"
        >
          <i className="fa-solid fa-arrow-up-right-from-square me-1"></i>
          사이트 이동
        </a>
      </div>
    </div>
  );
}
